angular.module('comment')
    .component('documentCommentsCount', {
        bindings: {
            document: '<'
        },
        controller: function ($element) {
            this.$onChanges = () => {
                const hasComments = this.document != null && this.document.commentsCount > 0;
                $element.css('display', hasComments ? '' : 'none');
            };
        },
        template: `
            <span class="document-info-header" title="Komentarzy: {{$ctrl.document.commentsCount}}">
                <i class="fa fa-fw fa-comment-o"></i>{{$ctrl.document.commentsCount}}
            </span>
        `
    })
